import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"

import { Container, Row, Col } from "./Grid"
import Link from "./Link"
import Button from "./Button"
import Markdown from "./Markdown"

import { media, mixins } from "../styles"

const CtaContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-weight: 300;
  justify-content: center;
  padding: 80px 0;
  text-align: center;

  @media ${media.lg} {
    padding: 125px 0;
  }

  @media print {
    display: none;
  }

  p {
    ${mixins.copy4}
    margin: 0 0 20px;

    @media ${media.xl} {
      margin: 0 0 30px;
    }
  }

  ${(props) =>
    props.$compact &&
    css`
      && {
        padding: 30px 0;
      }
    `}
`

const Header = styled.h2`
  ${mixins.title3}
  margin-bottom: 30px;

  ${(props) =>
    props.$sidePadding &&
    css`
      @media ${media.md} {
        padding: 0 30px;
      }

      @media ${media.xl} {
        padding: 0 60px;
      }
    `}
`

const Cta = ({
  header,
  text,
  linkText,
  linkUrl,
  compact,
  highlightButton,
  className,
}) => {
  const intl = useIntl()

  return (
    <Container className={className}>
      <CtaContainer $compact={compact ? 1 : 0}>
        <Row>
          <Col sm="10" smOffset="1" md="8" mdOffset="2" lg="6" lgOffset="3">
            {header && (
              <Header $sidePadding={intl.locale === "en"}>{header}</Header>
            )}
          </Col>
        </Row>
        <Row>
          <Col sm="10" smOffset="1" md="8" mdOffset="2" xl="6" xlOffset="3">
            {text && <Markdown>{text}</Markdown>}
            {linkText && linkUrl && (
              <Button
                as={Link}
                to={linkUrl}
                arrow
                highlight={highlightButton}
                intl={false}
              >
                {linkText}
              </Button>
            )}
          </Col>
        </Row>
      </CtaContainer>
    </Container>
  )
}

Cta.propTypes = {
  className: PropTypes.string,
  compact: PropTypes.bool,
  header: PropTypes.string,
  highlightButton: PropTypes.bool,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  text: PropTypes.string,
}

export default Cta
